import Vue from 'vue'
import rootApp from './components/rootApp.vue'


const hub = new Vue({
    render: h => h(rootApp)
}).$mount('#content');

window.addEventListener('popstate', function () {
    hub.currentRoute = window.location.pathname
})